var FORM_FACTOR = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    TABLET: 'tablet',
};
export default FORM_FACTOR;
//# sourceMappingURL=formFactor.js.map